import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import auth from "../../services/authService";
import Joi from "joi-browser";
import UploadDocument from "../../comman/UploadDocument";
import { getTotalHours } from "../../services/appService";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import Input from "../../comman/input";
import TextArea from "../../comman/textarea";
import { uploadFileToBlob } from "../../services/blobUploadService";
import { updateCandidateInvoicePayment, uploadCandidatePayDocument } from "../../app/store/candidate";

const schema = {
  paidAmount: Joi.number().required().label("Amount to Pay ($)"),
  invoiceAmount: Joi.number().required().label("Invoice Amount"),
};

function CandidatePay(props) {
  const {
    selectedObj,
    invType,
    timeLogInvoices,
    candidateObj,
    getInvoiceAmount,
    entType,
    payShowHide,
    handlePayShowHide,
    entityType
  } = props;

  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const [documents, setDocuments] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const dispatch = useDispatch();

  const validate = (currentData = data) => {
    const options = { abortEarly: false, allowUnknown: true };
    const result = Joi.validate(currentData, schema, options);
    if (!result.error) return null;
    const nextErrors = {};
    for (const item of result.error.details) {
      if (item.type === "any.required") nextErrors[item.path[0]] = item.message;
    }
    return Object.keys(nextErrors).length > 0 ? nextErrors : null;
  };

  const validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    if (schema[name] === undefined) return null;
    const fieldSchema = { [name]: schema[name] };
    const { error } = Joi.validate(obj, fieldSchema);
    return error ? error.details[0].message : null;
  };

  const handleChange = ({ currentTarget: input }) => {
    const nextErrors = { ...errors };
    const errorMessage = validateProperty(input);
    if (errorMessage) nextErrors[input.name] = errorMessage;
    else delete nextErrors[input.name];

    const nextData = { ...data, [input.name]: input.value };

    if (input.name === "paidAmount") {
      const invoiceAmount = parseFloat(nextData.invoiceAmount) || 0;
      const enteredAmount = parseFloat(input.value) || 0;

      if (enteredAmount > invoiceAmount) {
        nextErrors[input.name] =
          "Amount to Pay cannot be greater than Invoice Amount!";
      } else if (enteredAmount === 0) {
        nextErrors[input.name] = "Amount to Pay must be a number";
      } else {
        delete nextErrors[input.name];
      }
    }

    setData(nextData);
    setErrors(nextErrors);
  };

  const doSubmit = async () => {

    if (Object.keys(errors).length > 0) {
      getAlert("Please fill Appropriate data before Submission.", "", "error");
      return;
    }

    if (data.paidAmount === "") {
      getAlert("Please fill Appropriate data before Submission.", "", "error");
      return;
    }

    const resultAlert = await getConfirmAlert(
      "Are you sure?",
      "You want to Add payment",
      "warning"
    );


    if (resultAlert.isConfirmed) {
      const user = auth.getCurrentUser();
      const { wfTask: workflowTask, handlePayShowHide } = props;
      const payload = { ...data };
      let docId = 0;

      if (documents.length > 0 && workflowTask) {
        const frmData = new FormData();
        frmData.append("message", payload.payNotes);
        frmData.append("workflowTask", JSON.stringify(workflowTask));
        frmData.append("userId", user.id);
        frmData.append(
          "files",
          JSON.stringify(
            documents.map((file) => ({
              name: file.name,
              type: file.type,
              size: file.size,
            }))
          )
        );
        const result = await dispatch(uploadCandidatePayDocument(frmData));
        docId = result?.uploadId;
        if (docId > 0) {
          payload.payDocId = docId;
          await dispatch(updateCandidateInvoicePayment(payload));
          await Promise.all(
            documents.map((file, key) => {
              if (!file.file) return Promise.resolve();
              return uploadFileToBlob(
                file.file,
                result.sasUrls[key].uploadUrl,
                (progress) => {
                  console.log(`Upload progress for ${file.name}: ${progress}%`);
                }
              );
            })
          );
          handlePayShowHide("save");
          getAlert("Sent Successfully", "", "success");
        }
        return;
      }
      payload.payDocId = docId;
      await dispatch(updateCandidateInvoicePayment(payload));
      handlePayShowHide("save");
      getAlert("Sent Successfully", "", "success");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isProcessing) return;
    const formErrors = validate();
    setErrors(formErrors || {});
    if (formErrors) return;
    setIsProcessing(true);
    try {
      await doSubmit();
    } finally {
      setIsProcessing(false);
    }
  };

  const onFileChange = async (event) => {
    const docs = [...documents];
    for (const file of event.target.files) {
      docs.push({
        name: file.name,
        type: file.type,
        file,
        size: file.size,
      });
    }
    setDocuments(docs);
  };

  const handleFileRemove = (item) => {
    const index = documents.indexOf(item);
    if (index !== -1) {
      const nextDocuments = [...documents];
      nextDocuments.splice(index, 1);
      setDocuments(nextDocuments);
    }
  };

  const getPerdeimAmount = () => {
    const { getTotalDays, selectedObj, getFieldData, candidateObj } = props;
    if (!getTotalDays) return 0;
    const perfData = candidateObj.performerData;
    return (
      getTotalDays(selectedObj) *
      getFieldData(perfData, "candidateonboardingform", "Per_Diem_Rate")
    );
  };

  useEffect(() => {
    if (selectedObj !== undefined && selectedObj !== "") {
      const obj = selectedObj;
      const nextData = {};
      let candidateRate = 0;
      let invoType = invType;
      if (invType === "subcontractor") {
        if (entType === "C2C Basis" && candidateObj?.rates?.subcontractorRate) {
          candidateRate = candidateObj.rates.subcontractorRate;
        } else {
          if (candidateObj?.rates?.candidateRate) {
            candidateRate = candidateObj.rates.candidateRate;
          }
          invoType = "candidate";
        }
      }

      if (invType === "recruiter" && candidateObj?.rates?.recruiterRate) {
        candidateRate = candidateObj.rates.recruiterRate;
      }
      if (invType === "agency" && candidateObj?.rates?.agencyRate) {
        candidateRate = candidateObj.rates.agencyRate;
      }

      let fAmt = 0;
      if (invType === "subcontractor") {
        fAmt = parseFloat(getInvoiceAmount(obj));
      } else {
        fAmt = parseFloat(getTotalHours(obj?.workingHrs) * candidateRate);
      }
      const invItems = timeLogInvoices.filter((x) => x.timeLogId === obj.id);

      if (invItems.length > 0) {
        const selectedInvoice = invItems[0];
        if (selectedInvoice?.adjustmentMinues > 0) {
          fAmt -= selectedInvoice.adjustmentMinues;
        }
        if (selectedInvoice?.adjustmentPlus > 0) {
          fAmt += selectedInvoice.adjustmentPlus;
        }
        if (selectedInvoice?.adpDeduction > 0) {
          fAmt -= selectedInvoice.adpDeduction;
        }

        nextData.paymentMode = selectedInvoice.paymentMode;
        nextData.payNotes = selectedInvoice.payNotes;
        nextData.paidAmount = selectedInvoice.paidAmount;
        nextData.paymentDate = selectedInvoice.paymentDate?.split("T")[0];
      }

      nextData.id = obj.id;
      nextData.invoiceAmount = parseFloat(fAmt).toFixed(2);
      nextData.InvoiceType = invoType;
      nextData.paidAmount = parseFloat(fAmt).toFixed(2);

      setDocuments([]);
      setData(nextData);
      setErrors({});
    } else {
      setDocuments([]);
      setData({});
      setErrors({});
    }
  }, [
    selectedObj,
    invType,
    timeLogInvoices,
    candidateObj,
    getInvoiceAmount,
    entType,
  ]);

  const dueAmount = useMemo(() => {
    if (
      data.paidAmount !== undefined &&
      data.paidAmount !== "" &&
      data.paidAmount !== null
    ) {
      return parseFloat(
        parseFloat(data.invoiceAmount || 0) - parseFloat(data.paidAmount || 0)
      ).toFixed(2);
    }
    return parseFloat(data.invoiceAmount || 0).toFixed(2);
  }, [data.invoiceAmount, data.paidAmount]);

  const perDiem = useMemo(() => {
    if (props.selectedObj !== "") return getPerdeimAmount();
    return undefined;
  }, [props.selectedObj, props.getTotalDays, props.candidateObj]);

  const renderInput = (name, label, type = "text", forcedValue) => (
    <Input
      type={type}
      name={name}
      value={forcedValue ?? data[name] ?? ""}
      label={label}
      onChange={handleChange}
      error={errors[name]}
      req={schema[name]}
    />
  );

  const renderTextArea = (name, label) => (
    <TextArea
      name={name}
      value={data[name] || ""}
      label={label}
      onChange={handleChange}
      error={errors[name]}
      req={schema[name]}
    />
  );


  return (
    <>
      <style dangerouslySetInnerHTML={{
        __html: `
        /* Ensure the modal and backdrop are on top of other elements */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
          overflow-y: hidden !important;
        }

        /* Glassmorphic backdrop filter and blur */
        .modal-backdrop.show {
          backdrop-filter: blur(8px) !important;
          -webkit-backdrop-filter: blur(8px) !important;
          background-color: rgba(15, 23, 42, 0.45) !important;
          opacity: 1 !important;
        }

        /* Spring-like transition for scale-in animation */
        .modal.fade .wf-pay-modal.modal-dialog {
          transform: scale(0.95) !important;
          transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .modal.show .wf-pay-modal.modal-dialog {
          transform: scale(1) !important;
        }

        .wf-pay-modal {
          --task-accent: #2563eb; /* Primary Blue */
          --task-soft: #f8fafc;
          max-width: 760px !important;
          width: 100% !important;
        }

        .wf-pay-modal .modal-content {
          border-radius: 16px !important;
          border: none !important;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
          overflow: hidden !important;
          background: #ffffff !important;
        }

        .wf-pay-modal .modal-header {
          position: relative !important;
          display: block !important;
          padding: 22px 28px 18px 32px !important;
          background: linear-gradient(90deg, var(--task-soft) 0%, rgba(255,255,255,0.98) 54%, #ffffff 100%) !important;
          border-bottom: 1px solid #edf2f7 !important;
          overflow: hidden !important;
        }

        .wf-pay-modal .modal-header::before {
          content: "" !important;
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          bottom: 0 !important;
          width: 4px !important;
          background: var(--task-accent) !important;
        }

        .wf-pay-modal .rt-header-shell {
          display: flex !important;
          flex-direction: column !important;
          gap: 12px !important;
          width: 100% !important;
        }

        .wf-pay-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: flex-start !important;
          gap: 18px !important;
          width: 100% !important;
        }

        .wf-pay-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }

        .wf-pay-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 4px !important;
          min-width: 0 !important;
          padding-top: 2px !important;
        }

        .wf-pay-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #0f172a !important;
          font-size: 18px !important;
          font-weight: 850 !important;
          line-height: 1.2 !important;
          min-width: 0 !important;
        }

        .wf-pay-modal .rt-header-icon {
          width: 48px !important;
          height: 48px !important;
          min-height: 48px !important;
          border-radius: 10px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: var(--task-accent) !important;
          background: #ffffff !important;
          border: 1px solid var(--task-accent) !important;
          box-shadow: 0 8px 18px -12px rgba(15,23,42,0.28) !important;
          font-size: 18px !important;
          flex-shrink: 0 !important;
        }

        .wf-pay-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 10px !important;
          min-width: 0 !important;
          flex-wrap: wrap !important;
        }

        .wf-pay-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 4px 10px !important;
          border-radius: 999px !important;
          font-size: 10px !important;
          font-weight: 800 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          background: #eff6ff !important;
          color: var(--task-accent) !important;
          border: 1px solid rgba(37, 99, 235, 0.1) !important;
        }

        .wf-pay-modal .rt-modal-desc {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          color: #64748b !important;
          font-weight: 500 !important;
          line-height: 1.4 !important;
          font-size: 12px !important;
        }
        .wf-pay-modal .rt-modal-desc i {
          color: var(--task-accent) !important;
        }

        .wf-pay-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 36px !important;
          height: 36px !important;
          padding: 0 !important;
          font-size: 12px !important;
          font-weight: 700 !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
          outline: none !important;
        }
        .wf-pay-modal .rt-action-btn:hover {
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          background: #f8fafc !important;
          transform: translateY(-1px) !important;
        }
        .wf-pay-modal .rt-action-btn i {
          font-size: 11px !important;
          color: #94a3b8 !important;
        }
        .wf-pay-modal .rt-action-btn:hover i {
          color: #ef4444 !important;
        }

        .wf-pay-modal .modal-body {
          padding: 28px !important;
          background: #ffffff !important;
          max-height: calc(100vh - 250px) !important;
          overflow-y: auto !important;
        }

        .wf-pay-modal .form-group {
          margin-bottom: 20px !important;
        }

        .wf-pay-modal label {
          display: block !important;
          font-size: 12.5px !important;
          font-weight: 800 !important;
          color: #1e3a8a !important;
          margin-bottom: 8px !important;
          text-transform: uppercase !important;
          letter-spacing: 0.05em !important;
        }

        .wf-pay-modal .form-control {
          background: #ffffff !important;
          border: 1.5px solid #cbd5e1 !important;
          border-radius: 10px !important;
          padding: 10px 14px !important;
          font-size: 14px !important;
          font-weight: 600 !important;
          color: #1e293b !important;
          transition: all 0.2s ease !important;
          box-shadow: inset 0 2px 4px rgba(15, 23, 42, 0.02) !important;
          outline: none !important;
        }

        .wf-pay-modal .form-control:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12), inset 0 2px 4px rgba(15, 23, 42, 0.02) !important;
        }

        .wf-pay-modal textarea.form-control {
          min-height: 80px !important;
          resize: vertical !important;
        }

        /* Input prefix icons */
        .wf-pay-modal input[name="invoiceAmount"],
        .wf-pay-modal input[name="paidAmount"] {
          padding-left: 36px !important;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2364748b'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V19h-2.82v-.91c-1.39-.33-2.58-1.22-2.83-2.59h1.79c.21.64.76 1.09 1.48 1.15V13.8c-1.63-.44-2.82-1.32-2.82-3.1 0-1.61 1.09-2.68 2.38-2.97V7h2.82v.91c1.24.26 2.11 1.02 2.37 2.13h-1.8c-.18-.54-.62-.9-1.23-.96v2.79c1.69.49 2.82 1.34 2.82 3.19 0 1.64-1.07 2.76-2.4 3.03z'/%3E%3C/svg%3E") !important;
          background-repeat: no-repeat !important;
          background-position: 12px center !important;
          background-size: 16px 16px !important;
        }

        .wf-pay-modal input[name="paymentDate"] {
          padding-left: 36px !important;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2364748b'%3E%3Cpath d='M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z'/%3E%3C/svg%3E") !important;
          background-repeat: no-repeat !important;
          background-position: 12px center !important;
          background-size: 16px 16px !important;
        }

        /* Due Amount Highlight Card */
        .wf-pay-modal .wf-due-amount-value-card {
          height: 44px !important;
          display: flex !important;
          align-items: center !important;
          padding: 10px 14px 10px 36px !important;
          font-size: 14px !important;
          font-weight: 700 !important;
          border-radius: 10px !important;
          outline: none !important;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%231d4ed8'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V19h-2.82v-.91c-1.39-.33-2.58-1.22-2.83-2.59h1.79c.21.64.76 1.09 1.48 1.15V13.8c-1.63-.44-2.82-1.32-2.82-3.1 0-1.61 1.09-2.68 2.38-2.97V7h2.82v.91c1.24.26 2.11 1.02 2.37 2.13h-1.8c-.18-.54-.62-.9-1.23-.96v2.79c1.69.49 2.82 1.34 2.82 3.19 0 1.64-1.07 2.76-2.4 3.03z'/%3E%3C/svg%3E") !important;
          background-repeat: no-repeat !important;
          background-position: 12px center !important;
          background-size: 16px 16px !important;
          background-color: #eff6ff !important;
          border: 1.5px solid #bfdbfe !important;
          color: #1d4ed8 !important;
          box-shadow: inset 0 2px 4px rgba(15, 23, 42, 0.02) !important;
        }

        /* Per Diem Highlight Card */
        .wf-pay-modal .wf-perdiem-amount-value-card {
          height: 44px !important;
          display: flex !important;
          align-items: center !important;
          padding: 10px 14px 10px 36px !important;
          font-size: 14px !important;
          font-weight: 700 !important;
          border-radius: 10px !important;
          outline: none !important;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%237c3aed'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V19h-2.82v-.91c-1.39-.33-2.58-1.22-2.83-2.59h1.79c.21.64.76 1.09 1.48 1.15V13.8c-1.63-.44-2.82-1.32-2.82-3.1 0-1.61 1.09-2.68 2.38-2.97V7h2.82v.91c1.24.26 2.11 1.02 2.37 2.13h-1.8c-.18-.54-.62-.9-1.23-.96v2.79c1.69.49 2.82 1.34 2.82 3.19 0 1.64-1.07 2.76-2.4 3.03z'/%3E%3C/svg%3E") !important;
          background-repeat: no-repeat !important;
          background-position: 12px center !important;
          background-size: 16px 16px !important;
          background-color: #f5f3ff !important;
          border: 1.5px solid #ddd6fe !important;
          color: #7c3aed !important;
          box-shadow: inset 0 2px 4px rgba(15, 23, 42, 0.02) !important;
        }

        /* Payment Mode Selector Cards */
        .wf-pay-modal .wf-pay-section-label {
          font-size: 12.5px !important;
          font-weight: 800 !important;
          color: #1e3a8a !important;
          letter-spacing: 0.08em !important;
          text-transform: uppercase !important;
          margin-bottom: 12px !important;
          display: block !important;
        }

        .wf-pay-modal .wf-pay-mode-cards-group {
          display: flex !important;
          gap: 16px !important;
          width: 100% !important;
          margin-bottom: 24px !important;
        }

        .wf-pay-modal .wf-pay-mode-card-wrap {
          flex: 1 !important;
        }

        .wf-pay-modal .wf-pay-mode-radio-input {
          display: none !important;
        }

        .wf-pay-modal .wf-pay-mode-card {
          display: flex !important;
          align-items: center !important;
          gap: 16px !important;
          padding: 16px 20px !important;
          border-radius: 16px !important;
          border: 2px solid #e2e8f0 !important;
          background: #ffffff !important;
          cursor: pointer !important;
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
          margin-bottom: 0 !important;
          user-select: none !important;
          width: 100% !important;
          position: relative !important;
        }

        .wf-pay-modal .wf-pay-mode-card:hover {
          border-color: #cbd5e1 !important;
          background: #f8fafc !important;
          transform: translateY(-2px) !important;
          box-shadow: 0 8px 20px rgba(15, 23, 42, 0.06) !important;
        }

        .wf-pay-modal .wf-pay-mode-card-icon {
          font-size: 24px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
        }

        .wf-pay-modal .wf-pay-mode-card-text {
          display: flex !important;
          flex-direction: column !important;
          gap: 2px !important;
        }

        .wf-pay-modal .wf-pay-mode-card-title {
          font-size: 15px !important;
          font-weight: 800 !important;
          color: #0f172a !important;
        }

        .wf-pay-modal .wf-pay-mode-card-desc {
          font-size: 12px !important;
          color: #64748b !important;
          font-weight: 500 !important;
        }

        /* Active Radio Card Styles */
        .wf-pay-modal .cheque-card {
          --card-brand: #3b82f6;
          --card-bg-soft: rgba(59, 130, 246, 0.05);
          --card-shadow: rgba(59, 130, 246, 0.08);
        }
        .wf-pay-modal .cheque-card .wf-pay-mode-card-icon {
          color: #3b82f6 !important;
        }

        .wf-pay-modal .ach-card {
          --card-brand: #7c3aed;
          --card-bg-soft: rgba(124, 58, 237, 0.05);
          --card-shadow: rgba(124, 58, 237, 0.08);
        }
        .wf-pay-modal .ach-card .wf-pay-mode-card-icon {
          color: #7c3aed !important;
        }

        .wf-pay-modal .wf-pay-mode-radio-input:checked + .wf-pay-mode-card {
          border-color: var(--card-brand) !important;
          background: var(--card-bg-soft) !important;
          box-shadow: 0 8px 24px var(--card-shadow) !important;
          transform: translateY(-2px) !important;
        }

        .wf-pay-modal .wf-pay-mode-radio-input:checked + .wf-pay-mode-card::after {
          content: "\f058" !important;
          font-family: FontAwesome !important;
          position: absolute !important;
          top: 12px !important;
          right: 16px !important;
          font-size: 16px !important;
          color: var(--card-brand) !important;
        }

        /* Helper alerts */
        .wf-pay-modal .wf-pay-helper-alert {
          padding: 12px 16px !important;
          border-radius: 10px !important;
          font-size: 13px !important;
          font-weight: 600 !important;
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          margin-bottom: 20px !important;
          border: 1px solid transparent !important;
        }

        .wf-pay-modal .ach-alert {
          background: #f5f3ff !important;
          border-color: #ddd6fe !important;
          color: #6d28d9 !important;
        }

        .wf-pay-modal .cheque-alert {
          background: #eff6ff !important;
          border-color: #bfdbfe !important;
          color: #1e40af !important;
        }

        .wf-pay-modal .modal-footer {
          background: #f8fafc !important;
          border-top: 1px solid #edf2f7 !important;
          padding: 16px 24px !important;
          display: flex !important;
          justify-content: flex-end !important;
          gap: 12px !important;
        }

        .wf-pay-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          padding: 9px 20px !important;
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
        }
        .wf-pay-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
        }

        .wf-pay-modal .wf-btn-save {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          height: 38px !important;
          padding: 0 24px !important;
          border-radius: 8px !important;
          border: 1px solid rgba(37, 99, 235, 0.15) !important;
          background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;
          color: #ffffff !important;
          font-size: 13.5px !important;
          font-weight: 700 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15) !important;
        }
        .wf-pay-modal .wf-btn-save:hover {
          background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%) !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 6px 16px rgba(37, 99, 235, 0.2) !important;
        }
        .wf-pay-modal .wf-btn-save:active {
          transform: scale(0.97) !important;
        }
        .wf-pay-modal .wf-btn-save:disabled {
          background: #cbd5e1 !important;
          border-color: #cbd5e1 !important;
          color: #94a3b8 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
          transform: none !important;
        }
      `}} />
      <Modal show={payShowHide} size="xl" dialogClassName="wf-pay-modal" centered>
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i className="rt-header-icon fa fa-credit-card" aria-hidden="true" />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>
                        {invType === "subcontractor" && "Payment"}
                        {invType === "recruiter" && "Payment to Recruiter"}
                        {invType === "agency" && "Payment Received Status"}
                      </span>
                      <span className="rt-modal-title-badge">Transaction</span>
                    </span>
                  </h2>
                  <span className="rt-modal-desc">
                    <i className="fa fa-info-circle" aria-hidden="true" /> Record payments, set dates, specify payment modes, and add notes.
                  </span>
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={() => handlePayShowHide("close", "")}
                title="Close"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="border-0">
          <div className="row">
            {entityType === "W2 Basis" && invType === "subcontractor" ? (
              <div className="col-md-6">{renderInput("invoiceAmount", "Net Pay ($)", "number")}</div>
            ) : (
              <div className="col-md-4">{renderInput("invoiceAmount", "Invoice Amount ($)", "number")}</div>
            )}

            {!(entityType === "W2 Basis" && invType === "subcontractor") && (
              <div className="col-md-4">
                {renderInput(
                  "paidAmount",
                  `${invType === "agency"
                    ? "Payment Amount Received"
                    : "Amount to Pay ($)"
                  }`,
                  "number"
                )}
              </div>
            )}

            {entityType === "W2 Basis" && invType === "subcontractor" ? (
              <div className="col-md-6 form-group">
                <label className="form-control-label">Per Diem Amount ($)</label>
                <div className="wf-perdiem-amount-value-card">
                  {perDiem}
                </div>
              </div>
            ) : (
              <div className="col-md-4 form-group">
                <label className="form-control-label">Due Amount ($)</label>
                <div className="wf-due-amount-value-card">
                  {dueAmount}
                </div>
              </div>
            )}

            <div className="col-md-12">{renderInput("paymentDate", "Payment Date", "date")}</div>

            <div className="col-md-12">
              <span className="wf-pay-section-label">Payment Mode</span>
              <div className="wf-pay-mode-cards-group">
                <div className="wf-pay-mode-card-wrap">
                  <input
                    name="paymentMode"
                    type="radio"
                    id="byCheck"
                    className="wf-pay-mode-radio-input"
                    onChange={handleChange}
                    value="Cheque"
                    checked={data.paymentMode === "Cheque"}
                  />
                  <label className="wf-pay-mode-card cheque-card" htmlFor="byCheck">
                    <div className="wf-pay-mode-card-icon">
                      <i className="fa fa-money" aria-hidden="true" />
                    </div>
                    <div className="wf-pay-mode-card-text">
                      <span className="wf-pay-mode-card-title">By Cheque</span>
                      <span className="wf-pay-mode-card-desc">Pay using physical printed cheque</span>
                    </div>
                  </label>
                </div>

                <div className="wf-pay-mode-card-wrap">
                  <input
                    name="paymentMode"
                    type="radio"
                    id="byAch"
                    className="wf-pay-mode-radio-input"
                    onChange={handleChange}
                    value="ACH"
                    checked={data.paymentMode === "ACH"}
                  />
                  <label className="wf-pay-mode-card ach-card" htmlFor="byAch">
                    <div className="wf-pay-mode-card-icon">
                      <i className="fa fa-university" aria-hidden="true" />
                    </div>
                    <div className="wf-pay-mode-card-text">
                      <span className="wf-pay-mode-card-title">By ACH</span>
                      <span className="wf-pay-mode-card-desc">Direct electronic bank transfer</span>
                    </div>
                  </label>
                </div>
              </div>
            </div>

            {data.paymentMode && (
              <div className="col-md-12">
                {data.paymentMode === "ACH" && (
                  <div className="wf-pay-helper-alert ach-alert">
                    <i className="fa fa-info-circle" /> Payment will be processed via ACH Electronic Bank Transfer.
                  </div>
                )}
                {data.paymentMode === "Cheque" && (
                  <div className="wf-pay-helper-alert cheque-alert">
                    <i className="fa fa-info-circle" /> Payment will be processed via Physical printed Check.
                  </div>
                )}
              </div>
            )}

            <div className="col-md-12">{renderTextArea("payNotes", "Notes")}</div>

            <div className="col-md-12">
              <UploadDocument
                documents={documents}
                onFileChange={onFileChange}
                handleFileRemove={handleFileRemove}
                btnLable={`${entityType === "W2 Basis" ? "Upload Pay Slip" : "Add"}`}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={() => handlePayShowHide("close", "")}
          >
            <i className="fa fa-times" aria-hidden="true"></i> Close
          </button>
          <button
            className="wf-btn-save"
            onClick={handleSubmit}
            disabled={isProcessing || !!validate()}
          >
            <i
              className={`fa ${isProcessing ? "fa-spinner fa-spin" : "fa-paper-plane"}`}
              aria-hidden="true"
            ></i>{" "}
            Send
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CandidatePay;
